export default "__VITE_ASSET__Dk77ItBD__"